import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { getToken, getUserInfo } from './authentication';

export const AuthContext = React.createContext<any>({});

const Auth = ({ children }) => {
    const checkIsAuthenticated = () => {
        const isAuthenticated = sessionStorage.getItem('isAuthenticated');
        // we need to force the comparison as string since session storage items are strings.
        return isAuthenticated === 'true';
    };

    const userInfo = () => {
        const info = sessionStorage.getItem('userInfo');
        return info ? JSON.parse(info) : null;
    };

    const authenticateUser = async urlParams => {
        let userAuthenticated = false;
        let userInformation: object | null = null;
        try {
            const token = await getToken(urlParams);

            console.log('******************token****************=', token);
            if (token) {
                // todo: bh need to move this code away from shared-service,
                if (typeof token === 'string') {
                    sessionStorage.setItem('access_token', token);
                }
                // todo end
                const tokenUserInfo = await getUserInfo();
                if (tokenUserInfo) {
                    userInformation = tokenUserInfo;
                    userAuthenticated = true;
                }
            }
            sessionStorage.setItem('userInfo', userInformation ? JSON.stringify(userInformation) : '');
            sessionStorage.setItem('isAuthenticated', String(userAuthenticated));
            return userAuthenticated;
        } catch (err) {
            console.log('****************** token-error ****************=', err);
            localStorage.clear();
            sessionStorage.clear();
            return false;
        }
    };

    return <AuthContext.Provider value={ { checkIsAuthenticated, authenticateUser, userInfo } }>{children}</AuthContext.Provider>;
};

Auth.propTypes = {
    children: PropTypes.node.isRequired,
};

export default memo(Auth);
